import { z } from 'zod';

const PasswordSchema = z
  .string()
  .min(8, { message: 'Password must be greater than 8 characters' })
  .max(64, { message: 'Password must be less than 64 characters' })
  .refine((password) => /[A-Z]/.test(password), {
    message: 'Password must include an uppercase letter'
  })
  .refine((password) => /[a-z]/.test(password), {
    message: 'Password must include a lowercase letter'
  })
  .refine((password) => /[0-9]/.test(password), { message: 'Password must include a number' })
  .refine((password) => /[!@#$%^&*]/.test(password), {
    message: 'Password must include a special character !@#$%^&*'
  });

const ResetPasswordFormSchema = z
  .object({
    password: PasswordSchema,
    confirmPassword: PasswordSchema
  })
  .refine(({ password, confirmPassword }) => password === confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword']
  });
type ResetPasswordFormType = z.infer<typeof ResetPasswordFormSchema>;

export { ResetPasswordFormSchema };
export type { ResetPasswordFormType };
